( function( global, $ ) {
    "use strict";

    var BookingProcess = {};

    BookingProcess.onSubmit = function(ev) {
        var $form = $(this),
            $actionSelect = $form.find('[data-form-control="action"]'),
            $selectedOption = $actionSelect.find(':selected');

        if ($actionSelect.val().startsWith('view_contract:')
            || $actionSelect.val().startsWith('view_agreement:')
        ) {
            var $formAjaxAttr = $form.attr('data-form-ajax');
            $form.removeAttr('data-form-ajax');
            $form.attr('target', '_blank');
            setTimeout(function() {
                $actionSelect.val('');
                $form.attr('data-form-ajax', $formAjaxAttr);
            }, 150);

            return;
        }

        ev.preventDefault();

        if ($actionSelect.val() === '') {
            $form.data('form-state', 'incomplete');

            return;
        } else if($form.data('form-state') === 'incomplete') {
            $form.data('form-state', null);
        }

        if ($selectedOption.is('[data-option-delete]')) {
            if ($form.data('form-state') === 'confirmed') {
                $form.data('form-state', null);

                return;
            }

            $form.data('form-state', 'need-confirm');

            setTimeout(function() {
                if (confirm($selectedOption.data('option-delete'))) {
                    $form.data('form-state', 'confirmed');

                    $form.trigger('submit');
                } else {
                    $actionSelect.val('');
                    $form.data('form-state', null);
                }
            }, 100);
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form="booking-process"]');

        $form.on('submit', BookingProcess.onSubmit);

        $container.find('[selectize-multiple-bookingStatuses]').selectize({
            maxOptions: 5000,
            plugins: ['remove_button'],
            delimiter: ',',
            persist: false,
            highlight: false,
            onType: function (value) {
                this.$dropdown_content.unmark().mark(value);
            },
            onItemAdd: function () {
                this.clearCache('option');
                this.refreshOptions();
            },
            onItemRemove: function() {
                this.clearCache('option');
                this.refreshOptions();
            },
            render: {
                option: function(item, escape) {
                    var selected = this.getValue();
                    var data = this.$input.data('status-opposite');
                    var hiddenClass = '';
                    if (selected.length && data.hasOwnProperty(item.value)) {
                        $.each(data[item.value], function (key, value) {
                            if (-1 !== selected.indexOf(value)) {
                                hiddenClass = ' hidden';
                                return false;
                            }
                        });
                    }
                    return '<div class="option' + hiddenClass + '" data-selectable data-value="' + item.value + '">' + escape(item.text) + '</div>';
                }
            }
        });
    });

}( window.groots, jQuery ));
